import request from '@/utils/request'


// 查询公开课列表
export function listOpenCourse(query) {
  return request({
    url: '/openCourse/openCourse/list',
    method: 'get',
    params: query
  })
}

// 查询公开课分页
export function pageOpenCourse(query) {
  return request({
    url: '/openCourse/openCourse/page',
    method: 'get',
    params: query
  })
}

// 查询公开课详细
export function getOpenCourse(data) {
  return request({
    url: '/openCourse/openCourse/detail',
    method: 'get',
    params: data
  })
}

// 新增公开课
export function addOpenCourse(data) {
  return request({
    url: '/openCourse/openCourse/add',
    method: 'post',
    data: data
  })
}

// 修改公开课
export function updateOpenCourse(data) {
  return request({
    url: '/openCourse/openCourse/edit',
    method: 'post',
    data: data
  })
}

// 删除公开课
export function delOpenCourse(data) {
  return request({
    url: '/openCourse/openCourse/delete',
    method: 'post',
    data: data
  })
}
